import { render, staticRenderFns } from "./principalLayout.vue?vue&type=template&id=04fdd4a4&scoped=true&"
import script from "./principalLayout.vue?vue&type=script&lang=js&"
export * from "./principalLayout.vue?vue&type=script&lang=js&"
import style0 from "./principalLayout.vue?vue&type=style&index=0&id=04fdd4a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04fdd4a4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContent } from 'vuetify/lib/components/VContent';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VApp,VBtn,VContent,VSnackbar})
